/*
 FlagIcons


*/
import React, { Fragment } from 'react';
import { IconButton, Badge, Backdrop, Menu, MenuItem, Typography } from '@material-ui/core';

//import { connect } from 'react-redux';
//import {
//  AppState, Actions, store,
//  IPageState
//} from '../appredux'

import { Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import { PropTypes } from "@material-ui/core"

import LanguageIcon from '@material-ui/icons/Language';
import Flag from 'react-flagkit';
/*
Deklaracje dla react-flagkit (declare.d.ts):
declare module 'react-flagkit';

Aby sprawdzał, trzeba by całą deklarację:

import { Component } from 'react';

interface FlagProps {
    country?: string;
}        

declare class Flag extends Component<Props> { }

export default Flag;
*/


interface FlagProps {
  //page: IPageState;
  lang: string,
  setLang: (lang: string) => void
}

type FlagState = {
  anchorEl: any,
}

class FlagIconC extends React.Component<FlagProps & WithStyles<typeof styles>, FlagState> {

  constructor(props: any) {
    super(props, {});
    this.state = {
      anchorEl: null,
    }
  }

  openMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  findName = (name: string) => {
    const langNames = [
      { flag: 'pl', name: 'polski' },
      { flag: 'en', name: 'english' },
      { flag: 'de', name: 'deutsche' },
      { flag: 'sk', name: 'slovák' },
      { flag: 'cz', name: 'čeština' },
      { flag: 'ru', name: 'русский' },
      { flag: 'ua', name: 'українська' }
    ]

    let obj = langNames.find(x => x.flag === name)
    if (obj) {
      return obj.name
    } else {
      return ""
    }

  }

  //PM 2021-08-26
  //aktualizacja z zaktualizowana wersja react-flagkit
  render() {
    const { classes } = this.props;
    const openMenu = Boolean(this.state.anchorEl);
    const lang = ['pl', 'en']; //'cz', 'ru', 'ua'
    //const langNames = ['polski', 'english', 'deutsche', 'slovák', 'čeština', 'русский']

    let flgs: any[] = [];
    lang.forEach((c) => {
      if (lang.includes(c)) {
        let bg = '';
        let clr: PropTypes.Color;
        let cc: string;
        if (c == 'en') cc = 'GB'
        //      else if (c=='pl') cc='PL'
        else cc = c.toUpperCase()
        if (this.props.lang == c) { bg = 'A'; clr = 'primary' }
        else { bg = ''; clr = 'default' }
        flgs.push(
          <IconButton
            onClick={() => {
              //store.dispatch(Actions.pageState.setLangSms(c));
              this.props.setLang(c);
            }}
            color="inherit" key={c} style={{ padding: "12px 12px 6px 12px" }}
          >
            <Badge badgeContent={bg} color={clr}>
              <span>
                <Flag country={cc} size={30} />
              </span>
            </Badge>
          </IconButton>
        );
      }
    }
    );

    if(lang.length >= 4){
      if (this.props.lang !== lang[0] && this.props.lang !== lang[1] && this.props.lang !== lang[2] && this.props.lang !== lang[3]) {
        let index = flgs.findIndex((flag: any) => flag.key == this.props.lang)
        let flgsCopy = Object.create(flgs)
        let actual = flgsCopy.splice(index, 1);
  
        flgsCopy.shift()
        flgsCopy.shift()
        flgs = [flgs[0], flgs[1], actual].concat(flgsCopy)
      }
    }

    let flags: any[] = [];
    if (flgs.length <= 4) {
      flags = flgs
    } else {
      flags = flgs.slice(0, 4)
      flags.push(
        <IconButton onClick={this.openMenu} color="inherit" key={"..."} style={{ padding: "12px 12px 6px 12px", color: "#555" }}>
          <span
          //store.dispatch(Actions.pageState.setLang( c ));
          >
            <LanguageIcon style={{ fontSize: "1.2rem" }} color="primary" />
          </span>

        </IconButton>
      )
    }

    let menuFlags: any[] = [];
    lang.forEach((c, index) => {
      if (lang.includes(c)) {
        let bg = '';
        let clr: PropTypes.Color;
        let cc: string;
        if (c == 'en') cc = 'GB'
        else cc = c.toUpperCase()
        if (this.props.lang == c) { bg = 'A'; clr = 'primary' }
        else { bg = ''; clr = 'default' }
        menuFlags.push(
          <MenuItem key={index.toString()} className={classes.menuItem}
            onClick={() => {
              //store.dispatch(Actions.pageState.setLangSms(c))
              this.props.setLang(c);
              this.closeMenu()
            }} >
            <IconButton color="inherit" key={c} style={{ padding: "12px 12px 6px 12px" }}>
              <Badge badgeContent={bg} color={clr}>
                <Flag country={cc} size={30} />
              </Badge>
            </IconButton>
            <Typography variant="h6" component="h2" className={classes.text}>
              {"- " + this.findName(c)}
            </Typography>
          </MenuItem>
        );
      }
    }
    );



    return (
      <Fragment>
        {/* // <div >
    //     {flgs}
    // </div> */}
        <div className={classes.itnl}>
          {flags}
        </div>
        <Backdrop className={classes.backdrop} open={openMenu}>
          <Menu
            id="long-menu"
            anchorEl={this.state.anchorEl}
            keepMounted
            elevation={15}
            open={openMenu}
            onClose={this.closeMenu}
            PaperProps={{
              style: {
                //maxHeight: 10 * 4.5,
                width: '30ch',
                left: "200px",
                top: "200px"
                //paddingTop: "0"
              },
            }}

            MenuListProps={{
              style: {
                color: "#555",
                background: "linear-gradient(to bottom, #ffffff, #f7f7f7)"
              },
            }}
          >
            {menuFlags}
          </Menu>
        </Backdrop>
      </Fragment>
    )
  }
}

//const mapStateToProps = (state: AppState) => ({
//  page: state.pageState
//});


const styles = (theme: Theme) => ({
  itnl: {
    // marginLeft: "2em",
    // marginRight: '2em'
    //padding: '3.75px 2px 2px 2px',
    display: 'flex',
    //justifyContent: 'center',
    marginTop: "15px",
    marginBottom: "-35px"
  },
  flag: {
    width: "30px",
    height: "30px"
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  menuItem: {
    whiteSpace: "pre" as "pre",
    paddingBottom: "8px",
    paddingTop: "8px"
  },
  text: {
    paddingLeft: "15px",
    fontSize: "14px"
  }
});


//export default connect(mapStateToProps)(withStyles(styles)(FlagIconC));
export default withStyles(styles)(FlagIconC);

//export default FlagIcons

/*
old:
    let bgPL=''
    let plColor : PropTypes.Color = 'default'
    let enColor : PropTypes.Color = 'default'
    let bgEN=''
    if (this.props.page.langSms=='pl') {bgPL='A';plColor='secondary'}
    else  {bgEN='A';enColor= 'secondary'}


        <IconButton color="inherit">
        <Badge badgeContent={bgEN} color={ enColor }>
        <span onClick={ ()=>{
          store.dispatch(Actions.pageState.setLang('en'));
        }}>
        <Flag country="GB" />
        </span>
        </Badge>
        </IconButton>
        <IconButton color="inherit">
        <Badge badgeContent={bgPL} color={ plColor }>
        <span onClick={ ()=>{
          store.dispatch(Actions.pageState.setLang('pl'));
          }}>
        <Flag country="PL" />
        </span>
        </Badge>
        </IconButton>
*/